// extracted by mini-css-extract-plugin
module.exports = {"dialogPopup":"PledgeEstatePopup_dialogPopup__R2kJH","dialogBtn":"PledgeEstatePopup_dialogBtn__PGMLj"};